import dayjs from 'dayjs';
import React from 'react';
import { Formik, Form } from 'formik';

import { Grid } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

import { Button, TextField } from 'shared';
import {
    inventoryEmailSchema,
    inventoryEmailInitialValues,
} from 'components/Inventory/utils/inventoryEmailSchema';
import { activityFiltersStyles } from 'components/Inventory/style/style';

const InventoryEmailFilters = ({ handleFiltersSubmit }) => {
    const classes = activityFiltersStyles();

    const handleClearClick = (handleReset) => {
        handleReset();
        handleFiltersSubmit({});
    };

    const handleFormSubmit = (values) => {
        const filters = {
            ...values,
            date: values.date ? dayjs(values.date).format('YYYY-MM-DD') : null,
        };
        handleFiltersSubmit(filters);
    };

    return (
        <Formik
            onSubmit={handleFormSubmit}
            validationSchema={inventoryEmailSchema}
            initialValues={inventoryEmailInitialValues}
        >
            {({ values, handleReset, handleChange, setFieldValue }) => {
                return (
                    <Form>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12} lg={6}>
                                <TextField
                                    fullWidth
                                    name="searchText"
                                    inlineLabel="Search by keywords"
                                    value={values.searchText}
                                    placeholder="Search by keywords"
                                    onChange={handleChange}
                                    customStyle={classes.inputField}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={values.date && dayjs(values.date)}
                                        onChange={(date) => setFieldValue('date', date)}
                                        label="Date"
                                        placeholder="Select Date"
                                        format="MM-DD-YYYY"
                                        sx={classes.datePicker}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <TextField
                                    fullWidth
                                    name="amount"
                                    inlineLabel="Amount"
                                    value={values.amount}
                                    placeholder="Search by amount"
                                    customStyle={classes.inputField}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (/^-?\d*\.?\d*$/.test(val)) {
                                            handleChange(e);
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} alignItems="center" justifyContent="flex-end">
                            <Grid item marginTop="10px" marginBottom="10px">
                                <Button
                                    text="Clear"
                                    onClick={() => handleClearClick(handleReset)}
                                    customStyles={classes.clearButton}
                                />
                                <Button text="Apply" type="submit" />
                            </Grid>
                        </Grid>
                    </Form>
                );
            }}
        </Formik>
    );
};

export default InventoryEmailFilters;
